import Rails from '@rails/ujs';
import TemplateValidation from "../utils/TemplateValidation";

export default class BaseEligibilityIndex {

    constructor() {
        this.fttoDatatables = [];
        this.fonDataTable = null;
        this.otherDatatables = [];

        this.placesAddress = null;
        this.placesAddressA = null;
        this.placesAddressB = null;
        this.placesAddressWithoutApi = null;
        
        this.testValidation = null;
        this.fonExportValidation = null;
        this.fttoExportValidation = null;

        this.bindEvents();

        this.setDatatables();
        this.initAutocompletePlaces();
        this.initValidation();
        this.toggleSolution();
    }

    bindEvents() {
        $("#service_id").on("change", (e) => this.onSolutionChange(e));
        $("#eligibility_request").on("submit", (e) => this.onSubmitTestEligibility(e));
        $(".js-export-fon").on("click", (e) => this.onExportFon(e));
        $(".js-export-ftto").on("click", (e) => this.onExportFtto(e));
    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.fttoDatatables.forEach((table) => {
            table.destroy();
        });
        this.fttoDatatables = [];
        this.otherDatatables.forEach((table) => {
            table.destroy();
        });
        this.otherDatatables = [];

        $("#service_id").off("change", this.onSolutionChange);
        $("#eligibility_request").off("submit", this.onSubmitTestEligibility);
        $(".js-export-fon").off("click", this.onExportFon);
        $(".js-export-ftto").off("click", this.onExportFtto);

        if(this.testValidation !== null){
            this.testValidation.onDestroy();
            this.testValidation = null;
        }

        if(this.fonExportValidation !== null){
            this.fonExportValidation.onDestroy();
            this.fonExportValidation = null;
        }

        if(this.fttoExportValidation !== null){
            this.fttoExportValidation.onDestroy();
            this.fttoExportValidation = null;
        }
    }

    setDatatables() {
        this.initFttoDatatables();
        this.initSingleAdressDatatable();
        this.initDoubleAdressDatatable();
    }

    initFttoDatatables(){
        let $els = $('.ftto_datatable');
        if($els.length <= 0){ return false; }

        $els.each((index, el) => {
            let $el = $(el);
            let table = $el.DataTable({
                dom: 'rtp',
                responsive: false,
                serverSide: true,
                "pageLength": 20,
                order: [[0, 'desc']],
                language: require('../../backoffice/utils/plugins/datatables_translation/'+I18n.locale+'.json'),
                columnDefs: [
                    { orderable: false, searchable: false, targets: -1 },
                    { orderable: false, searchable: false, targets: 2 },
                ],
                "ajax": {
                    'url': $el.data("url"),
                    'data': function(data){
                        //data.search["value"] = $("#client_search").val();
                    }
                },
                "columns": [
                    { "data": "created_at" },
                    { "data": "address" },
                    { "data": "coordinates", "orderable": false },
                    { "data": "result" },
                    { "data": "actions", "orderable": false },
                ],
                initComplete: () => {
                    if (this.bindDetailButtons) {
                        this.bindDetailButtons();
                    }
                }
            });

            this.fttoDatatables.push(table);

            let $search = $('#' + $el.data("service-name") + 'CustomSearch');

            if ($search.length !== 0) {
                $search.keyup(function() {
                    table.search($(this).val()).draw();
                });
            }
        });
    }

    initNoServiceDatatables(selector, columns) {
        let $els = $(selector);
        if ($els.length <= 0) { return false; }
    
        $els.each((index, el) => {
            let $el = $(el);
            let table = $el.DataTable({
                dom: 'rtp',
                responsive: false,
                serverSide: true,
                "pageLength": 20,
                order: [[0, 'desc']],
                language: require('../../backoffice/utils/plugins/datatables_translation/' + I18n.locale + '.json'),
                columnDefs: [
                    { orderable: false, searchable: false, targets: -1 },
                    { orderable: false, searchable: false, targets: 2 },
                ],
                "ajax": {
                    'url': $el.data("url"),
                    'data': function(data) {
                        //data.search["value"] = $("#client_search").val();
                    }
                },
                "columns": columns,
                initComplete: () => {
                    if (this.bindDetailButtons) {
                        this.bindDetailButtons();
                    }
                }
            });
    
            this.otherDatatables.push(table);
    
            let $search = $('#' + $el.data("service-name") + 'CustomSearch');
            if ($search.length !== 0) {
                $search.keyup(function() {
                    table.search($(this).val()).draw();
                });
            }
        });
    }

    initSingleAdressDatatable() {
        this.initNoServiceDatatables('.other-datatable', [
            { "data": "created_at" },
            { "data": "address" },
            { "data": "coordinates", "orderable": false },
            { "data": "last_checked_at", "orderable": false },
            { "data": "actions", "orderable": false },
        ]);
    }
    
    initDoubleAdressDatatable() {
        this.initNoServiceDatatables('.other-datatable-double-address', [
            { "data": "created_at" },
            { "data": "address" },
            { "data": "coordinates", "orderable": false },
            { "data": "secondary_address" },
            { "data": "secondary_coordinates", "orderable": false },
            { "data": "last_checked_at", "orderable": false },
            { "data": "actions", "orderable": false },
        ]);
    }

    onSolutionChange(e) {
        this.toggleSolution();
    }

    toggleSolution(){
        let $el = $("#service_id option:selected");
        
        if($el.data("api") == "api_type_ftto_one" || $el.data("api") == "api_type_ftto_tree") {
            $("#double-address-container").hide();
            $("#no-service-container").hide();

            $("#ftto-container").show();

            $("#no-service-address").val("");
            $("#address_a").val("");
            $("#address_b").val("");

            $("#address_a").rules("remove", "required");
            $("#address_b").rules("remove", "required");
        } else {
            if ($el.data("use-two-addresses") == true) { 
                $("#ftto-container").hide();
                $("#no-service-container").hide();

                $("#double-address-container").show();
                
                $("#no-service-address").val("");
                $("#address").val("");

                $("#address_a").rules("add", { required: true });
                $("#address_b").rules("add", { required: true });
            } else {
                $("#double-address-container").hide();
                $("#ftto-container").hide();

                $("#no-service-container").show();  

                $("#address").val("");
                $("#address_a").val("");
                $("#address_b").val("");

                $("#address_a").rules("remove", "required");
                $("#address_b").rules("remove", "required");
            }
        }
    }

    initAutocompletePlaces() {
        //autocomplete options
        const options = {
            componentRestrictions: { country: "fr" },
            types: ['address'],
        };
        //autocomplete offer 1
        this.placesAddress = new google.maps.places.Autocomplete(document.getElementById("address"), options);

        //autocomplete offer2
        this.placesAddressA = new google.maps.places.Autocomplete(document.getElementById("address_a"), options);
        this.placesAddressB = new google.maps.places.Autocomplete(document.getElementById("address_b"), options);

        //autocomplete no service
        this.placesAddressWithoutApi = new google.maps.places.Autocomplete(document.getElementById("no-service-address"), options);
    }

    onSubmitTestEligibility(e){
        e.preventDefault();
        let $el = $(e.currentTarget)

        if(!$el.valid()){ return false; }
        application.openLoader();
        
        let formData = new FormData();
        formData.append('address', $("#address").val() || $("#no-service-address").val());
        formData.append('address_a', $("#address_a").val());
        formData.append('address_b', $("#address_b").val());
        formData.append('service_id', $("#service_id").val());

        Rails.ajax({
            url: $el.data("url"),
            type: "POST",
            data: formData,
            success: (data) => this.testEligibilitySuccess(data),
            error: (xhr) => this.testEligibilityError(xhr)
        });
    }

    testEligibilitySuccess(data){
        application.closeLoader();
        Turbolinks.visit(data.redirect_url)
    }

    testEligibilityError(xhr){
        application.closeLoader();
        if(xhr.status === 404){
            $("#info_modal").modal("show")
            $("#info_modal #infoModalTitle").html(I18n.t("extranet.eligibility.index.test_eligibility_result.no_token_title"))
            $("#info_modal #infoModalContent").html(I18n.t("extranet.eligibility.index.test_eligibility_result.no_token_message"))
        }else{
            $("#info_modal").modal("show")
            $("#info_modal #infoModalTitle").html(I18n.t("extranet.eligibility.index.test_eligibility_result.request_error_title"))
            $("#info_modal #infoModalContent").html(xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : xhr.statusText || "Une erreur est survenue")
        }
    }

    initValidation() {
        this.testValidation = new TemplateValidation(this.validationUpdateData(), "#eligibility_request");
        this.fonExportValidation = new TemplateValidation(this.validationFonExportData(), "#export_fon_form");
        this.fttoExportValidation = new TemplateValidation(this.validationFttoExportData(), "#export_ftto_form");
    }

    validationUpdateData() {
        return {
            "address": {
                required: true
            },
            "service_id": {
                required: true
            }
        };
    }

    validationFonExportData() {
        return {
            "export_fon_start_date": {
                required: true
            },
            "export_fon_end_date": {
                required: true,
                greater_than: "#export_fon_start_date"
            }
        };
    }

    validationFttoExportData() {
        return {
            "export_ftto_start_date": {
                required: true
            },
            "export_ftto_end_date": {
                required: true,
                greater_than: "#export_ftto_start_date"
            }
        };
    }

    onExportFon(e){
        e.preventDefault();
        let $el = $(e.currentTarget)
        let self = application.current_handler;

        if(!$("#export_fon_form").valid()){ return false; }

        $("#export_fon_modal").modal("hide")

        self.exportRequests(
            $el.data("url"),
            $("#export_fon_start_date").val(),
            $("#export_fon_end_date").val()
        );
    }

    onExportFtto(e){
        e.preventDefault();
        let $el = $(e.currentTarget)
        let self = application.current_handler;

        if(!$("#export_ftto_form").valid()){ return false; }

        $("#export_ftto_modal").modal("hide")

        self.exportRequests(
            $el.data("url"),
            $("#export_ftto_start_date").val(),
            $("#export_ftto_end_date").val()
        );
    }

    exportRequests(url, start_date, end_date){
        application.openLoader();

        Rails.ajax({
            url: url,
            type: "POST",
            data: {
                start_date: start_date,
                end_date: end_date
            },
            success: (data) => {
                application.closeLoader();
                window.open(data.url, '_blank')
            }
        })
    }
}